var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.step > 1)?_c('el-steps',{attrs:{"active":_vm.step,"align-center":""}},[_c('el-step',{attrs:{"title":"活动介绍"}}),_c('el-step',{attrs:{"title":"设置规则"}}),_c('el-step',{attrs:{"title":"活动投放"}})],1):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }